'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  NONE: null,
  IMAGE_SLIDER: null,
  FORM: null,
  SOCIAL_SHARING: null,
  POST_LISTING: null,
  FOLLOW_ME: null,
  POST_FILTER: null,
  CTA: null,
  HERO_IMAGE: null,
  NAV_MENU: null,
  SUB_MENU: null,
  BACKGROUND_IMAGE: null,
  BACKGROUND_VIDEO: null,
  BLOG_EMAIL_SUBSCRIPTION: null,
  MAP: null,
  PRICING_TABLE: null
});